import {
  LOAD_FIND_PRODUCTS_TOP_CATEGORIES,
  LOAD_FIND_PRODUCTS_CHILD_CATEGORIES,
  LoadFindProductsTopCategoriesAction,
  LoadFindProductsChildCategoriesAction,
  CLOSE_ALL_FIND_PRODUCT_SUBSCRIPTIONS,
  LoadProductsFromCategoryForFindProductsCategoryAction,
  LOAD_PRODUCTS_FOR_FIND_PRODUCTS_CATEGORY,
  UpdateProductsCategoryAction,
  CHANGE_PRODUCTS_CATEGORY,
  UpdateProductsCategoryPayload,
  GetProductListPayload,
  FETCH_PRODUCTS_FOR_FIND_PRODUCTS,
  FETCH_PRODUCT_IDS_FOR_FIND_PRODUCTS_CATEGORY,
  QUERY_PRODUCT_FOR_FIND_PRODUCTS,
  QueryProductForFindProductsPayload,
  QueryProductForFindProductsAction,
  RESET_QUERY_PRODUCT_FOR_FIND_PRODUCTS,
  ResetQueryProductForFindProductsAction,
  RESET_FIND_PRODUCTS,
  ResetFindProductsAction,
  UPDATE_FIND_PRODUCTS_PROGRESS_CACHE,
  RESET_FIND_PRODUCTS_PROGRESS_CACHE,
  UpdateFindProductsProgressCacheAction,
  LOAD_FIND_PRODUCTS_PAGE_DETAILS,
  LOAD_FIND_PRODUCTS_PAGE_DETAILS_COMPLETE,
  LoadFindProductsPageDetailsPayload,
  LoadFindProductsPageDetailsAction,
} from "./FindProductsTypes";

export const loadFindProductsTopCategoriesByCatalogId = (
  catalogId: string,
  localeId: string,
  storeId: string,
): LoadFindProductsTopCategoriesAction => {
  return {
    type: LOAD_FIND_PRODUCTS_TOP_CATEGORIES,
    payload: {
      catalogId,
      localeId,
      storeId,
    },
  };
};

export const loadFindProductsChildCategories = (
  catalogId: string,
  categoryId: string,
  localeId: string,
  storeId: string,
): LoadFindProductsChildCategoriesAction => {
  return {
    type: LOAD_FIND_PRODUCTS_CHILD_CATEGORIES,
    payload: {
      catalogId,
      categoryId,
      localeId,
      storeId,
    },
  };
};

export const closeFindProductsSubscriptionsAndResetState = (
  catalog: string,
) => ({
  type: CLOSE_ALL_FIND_PRODUCT_SUBSCRIPTIONS,
  payload: {
    catalog,
  },
});

export const loadProductsFromFindProductsCategory = (payload: {
  catalogId: string;
  categoryId: string;
  localeId: string;
  storeId: string;
  orderBy?: string;
}): LoadProductsFromCategoryForFindProductsCategoryAction => {
  return {
    payload,
    type: LOAD_PRODUCTS_FOR_FIND_PRODUCTS_CATEGORY,
  };
};

export const updateProductsCategory = (
  payload: UpdateProductsCategoryPayload,
): UpdateProductsCategoryAction => {
  return {
    payload,
    type: CHANGE_PRODUCTS_CATEGORY,
  };
};

export const loadProductsListForFindProductsModal = (
  payload: GetProductListPayload,
) => {
  return {
    payload,
    type: FETCH_PRODUCTS_FOR_FIND_PRODUCTS.REQUEST,
  };
};

export const loadProductIdsFromFindProductsCategory = (
  payload: GetProductListPayload,
) => {
  return {
    payload,
    type: FETCH_PRODUCT_IDS_FOR_FIND_PRODUCTS_CATEGORY.REQUEST,
  };
};

export const queryProductForFindProducts = (
  payload: QueryProductForFindProductsPayload,
): QueryProductForFindProductsAction => {
  return {
    payload,
    type: QUERY_PRODUCT_FOR_FIND_PRODUCTS.REQUEST,
  };
};

export const resetQueryProductForFindProducts = (): ResetQueryProductForFindProductsAction => {
  return {
    type: RESET_QUERY_PRODUCT_FOR_FIND_PRODUCTS,
  };
};

export const resetFindProducts = (): ResetFindProductsAction => {
  return {
    type: RESET_FIND_PRODUCTS,
  };
};

export const updateFindProductsProgressCache = (
  page: number,
  progress: number,
): UpdateFindProductsProgressCacheAction => ({
  type: UPDATE_FIND_PRODUCTS_PROGRESS_CACHE,
  payload: { page, progress },
});

export const resetFindProductsProgressCache = () => ({
  type: RESET_FIND_PRODUCTS_PROGRESS_CACHE,
});

export const loadFindProductsPageDetails = (
  payload: LoadFindProductsPageDetailsPayload,
): LoadFindProductsPageDetailsAction => ({
  type: LOAD_FIND_PRODUCTS_PAGE_DETAILS,
  payload,
});

export const loadFindProductsPageDetailsComplete = () => ({
  type: LOAD_FIND_PRODUCTS_PAGE_DETAILS_COMPLETE,
});